import React from "react";

export default function PackageDescription({ Item }) {
  return (
    <div>
      <h5>Details</h5>
      <p>{Item?.details}</p>
      {/* <span>
        <strong>benefits: </strong>
      </span>
      <div>
        <ul>
          <li>Venue hire on the day of the wedding.</li>
          <li>
            Setup of wedding hall including; luxury table linen and chair
            covers.
          </li>
          <li>Exclusive use of the pre-function area.</li>
          <li>Exclusive use of bridal room for the bride and bridal party.</li>
          <li>
            Al Majlis Venue can be used for gentlemen at an additional charge.
          </li>
          <li>
            A three tier of 4kg wedding cake designed by our Pastry Artist.
          </li>
          <li>Complimentary Self car parking for wedding guests.</li>
          <li>Valet car parking at an additional cost.</li>
          <li>
            Ladies service staff and security on the day of wedding at an
            additional cost.
          </li>
          <li>
            The wedding night stay in a Luxury Suite inclusive of dinner and
            breakfast in the suite.Romantic room setup.
          </li>
          <li>
            Early check-in (subject to availability) and late check-out until
            04:00 PM
          </li>
          <li>Special room rate for the wedding guests.</li>
          <li>
            Authentic Arabic coffee & tea, chilled juices and bottled water.
          </li>
          <li>
            international buffet menu (1 Assorted Cheese Mirror, 6 cold Mezzeh,
            2 Hot Mezzeh, 4 salads, 8 main courses & 5 desserts).
          </li>
        </ul>
      </div>
      <hr /> */}

      <div>
        <span>
          <strong>Extra Items & Services:</strong>
        </span>
        <ul>{Item?.about}</ul>
      </div>
      <hr />

      <div>
        <span>
          <strong>Terms &amp; Conditions:&nbsp;</strong>
        </span>
        <ul>
          <li>Rate: BD {Item?.price} per person</li>
        </ul>
      </div>

      <hr />
      <div>{Item?.terms_and_conditions}</div>
    </div>
  );
}
